import React, {useState, useEffect} from "react";
import 'moment/locale/es';
import './MiPerfil.css';
import useValidatorforms from "happ-custom-hooks/useValidatorforms";
import useAuthSession from "happ-custom-hooks/useAuthSession";
import moment from "moment"

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Datetime from "react-datetime";
import Today from "@material-ui/icons/Today";
import Loyalty from "@material-ui/icons/Loyalty";

// @material-ui/icons
import PermIdentity from "@material-ui/icons/PermIdentity";

//happ-icons 
import { IconUser, IconCalendar, IconFicha } from "happ-components/happ-icons/icons";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import CustomInput from "components/CustomInput/CustomInput.js";
import Clearfix from "components/Clearfix/Clearfix.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Timeline from "components/Timeline/Timeline.js";
import CardIcon from "components/Card/CardIcon.js";
import Favorite from "@material-ui/icons/Favorite";


import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
const useStyles = makeStyles(styles);

let initState = {
  dni: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  gender: '',
  healthForecast: '',
  birthDay: '',
  street: '',
  commune: '',
  region: '',
  company: '',
  branchOffice: '',
};

export default function MiPerfil() {
  const widgetStories = [
    {
      // First story
      inverted: true,
      badgeColor: "danger",
      badgeIcon: Loyalty,
      title: "Titulo Determinación",
      titleColor: "danger",
      body: (
        <p>
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
          Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
          when an unknown printer took a galley of type and scrambled it to make a type specimen book.
        </p>
      ),
      footerTitle: "28-abril-2022",
    },
    {
      // Second story
      inverted: true,
      badgeColor: "success",
      badgeIcon: Loyalty,
      title: "Titulo Determinación",
      titleColor: "success",
      body: (
        <p>
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
          Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
          when an unknown printer took a galley of type and scrambled it to make a type specimen book.
        </p>
      ),
      footerTitle: "10-abril-2022",      
    },
    {
      // Third story
      inverted: true,
      badgeColor: "info",
      badgeIcon: Loyalty,
      title: "Titulo Determinación",
      titleColor: "info",
      body: (
        <div>
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
            when an unknown printer took a galley of type and scrambled it to make a type specimen book.
          </p>
        </div>
      ),
      footerTitle: "20-marzo-2022",      
    },
  ];
  const classes = useStyles();
  
  let profile = useAuthSession();
  let formatDate;
  if ( profile.birthDay ) {
    formatDate =  moment.utc( profile.birthDay ).format('YYYY-MM-DD');
  }
  initState.firstName = profile?.firstName;
  initState.lastName = profile?.lastName;
  initState.dni = profile?.dni;
  initState.email = profile?.email;
  initState.phone = profile?.phone;
  initState.company = profile?.company?.name;
  initState.birthDay = formatDate;
  initState.gender = profile?.gender;
  initState.healthForecast = profile?.healthForecast;
  initState.street = profile?.address?.length > 0 ? profile.address[0].street : '';
  initState.commune = profile?.address?.length > 0 ? profile.address[0].commune : '';
  initState.region = profile?.address?.length > 0 ? profile.address[0].region : '';


  const {
    state,
    errors,
    comunes,
    stateReg,
    handlerSubmit,
    handlerChange,
    handlerDateChange,
    handlerChangeReg
  } = useValidatorforms(initState, updateProfile);

  const {
    dni,
    firstName,
    lastName,
    email,
    phone,
    gender,
    healthForecast,
    birthDay,
    street,
    commune,
    region,
    company,
    branchOffice
  } = state;

  function updateProfile() {
    console.log('Funcionando ....');
  }
  
  let inputProps = {
    placeholder: 'Fecha de nacimiento',
    name: 'birthDay',
    value: birthDay ? birthDay : ''
  }


  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon className={`${classes.iconBack} content-icons`}>
                <IconUser />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                Editar Perfil - <small>Completa tu perfil</small>
              </h4>
            </CardHeader>
            <CardBody>
              <form
                onSubmit={handlerSubmit}
              >
                <GridContainer>
                  <GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      labelText="Empresa (Opcional)"
                      id="company"
                      onChange={handlerChange}
                      value={company ? company : ''}
                      name="company"
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="RUT ó DNI"
                      id="dni"
                      onChange={handlerChange}
                      value={dni ? dni : ''}
                      name="dni"
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  <p>{errors.dni && errors.dni}</p>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="Email"
                      id="email"
                      onChange={handlerChange}
                      value={email ? email : ''}
                      name="email"
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  <p>{errors.email && errors.email}</p>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="Nombres"
                      id="firstName"
                      onChange={handlerChange}
                      value={firstName ? firstName : ''}
                      name="firstName"
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  <p>{errors.first_name && errors.first_name}</p>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="Apellidos"
                      id="lastName"
                      onChange={handlerChange}
                      value={lastName ? lastName : ''}
                      name="lastName"
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  <p>{errors.last_name && errors.last_name}</p>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        labelText="Teléfono"
                        id="phone"
                        onChange={handlerChange}
                        name="phone"
                        value={phone ? phone : ''}
                        formControlProps={{
                          fullWidth: true,
                        }}
                      />
                      <p>{errors.phone && errors.phone}</p>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                      <GridItem xs={12} sm={12} md={4}>
                        <FormControl
                          fullWidth
                          className={classes.selectFormControl}
                        >
                          <InputLabel
                            htmlFor="gender"
                            className={classes.selectLabel}
                          >
                            Genero
                          </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu,
                            }}
                            classes={{
                              select: classes.select,
                            }}
                            value={gender ? gender : ''}
                            onChange={handlerChange}
                            inputProps={{
                              name: "gender",
                              id: "gender",
                            }}
                          >
                            <MenuItem
                              disabled
                              classes={{
                                root: classes.selectMenuItem,
                              }}
                              value=""
                            >
                              Genero
                            </MenuItem>
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value="F"
                            >
                              Femenino
                            </MenuItem>
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value="M"
                            >
                              Masculino
                            </MenuItem>
                          </Select>
                        </FormControl>
                        <p>{errors.gender && errors.gender}</p>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={8}>
                        <FormControl
                          fullWidth
                          className={classes.selectFormControl}
                        >
                          <InputLabel
                            htmlFor="healthForecast"
                            className={classes.selectLabel}
                          >
                            Previsión de salud
                          </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu,
                            }}
                            classes={{
                              select: classes.select,
                            }}
                            value={healthForecast ? healthForecast : ''}
                            onChange={handlerChange}
                            inputProps={{
                              name: "healthForecast",
                              id: "healthForecast",
                            }}
                          >
                            <MenuItem
                              disabled
                              classes={{
                                root: classes.selectMenuItem,
                              }}
                              value=""
                            >
                              Previsión de salud
                            </MenuItem>
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value="Fonasa"
                            >
                              Fonasa
                            </MenuItem>
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value="Isapre Colmena"
                            >
                              Isapre Colmena
                            </MenuItem>
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value="Isapre Cruz Blanca"
                            >
                              Isapre Cruz Blanca
                            </MenuItem>
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value="Isapre Banmédica"
                            >
                              Isapre Banmédica
                            </MenuItem>
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value="Isapre Consalud"
                            >
                              Isapre Consalud
                            </MenuItem>
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value="Isapre Vida tres"
                            >
                              Isapre Vida tres
                            </MenuItem>
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value="Isapre Nueva masvida"
                            >
                              Isapre Nueva masvida
                            </MenuItem>
                          </Select>
                          <p>{errors.health_forecast && errors.health_forecast}</p>
                        </FormControl>
                      </GridItem>
                </GridContainer>
                <br />
                <GridContainer>                
                  <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="Dirección"
                        id="address_0"
                        onChange={handlerChange}
                        name="street"
                        value={street ? street : ''}
                        formControlProps={{
                          fullWidth: true,
                        }}
                      />
                  <p>{errors.street && errors.street}</p>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <FormControl
                      fullWidth
                      className={`${classes.selectFormControl}`}
                    >
                      <InputLabel
                        htmlFor="region"
                        className={`${classes.selectLabel} label-custom-reg`}
                      >
                        Región
                      </InputLabel>
                      <Select
                        MenuProps={{
                          className: `${classes.selectMenu}`,
                        }}
                        classes={{
                          select: `${classes.select} select-custom-reg`,
                        }}
                        value={region ? region : ''}
                        onChange={handlerChangeReg}
                        inputProps={{
                          name: "region",
                          id: "region",
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classes.selectMenuItem,
                          }}
                          value=""
                        >
                          Selecione una región
                        </MenuItem>
                        {stateReg && Object.keys(stateReg).length > 0 ? (
                          stateReg.map(reg => (
                            <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value={reg.name}
                            key={reg.id}
                          >
                            {reg.name}
                          </MenuItem>
                          ))
                        ) : null}
                      </Select>
                    <p>{errors.region && errors.region}</p>
                    </FormControl>
                  </GridItem> 
                  <GridItem xs={12} sm={12} md={3}>
                    <FormControl
                      fullWidth
                      className={`${classes.selectFormControl}`}
                    >
                      {comunes && Object.keys(comunes).length > 0 ? (
                      <>  
                        <InputLabel
                          htmlFor="commune"
                          className={`${classes.selectLabel} label-custom-reg`}
                        >
                          Comuna / Provincia
                        </InputLabel>
                        <Select
                          MenuProps={{
                            className: `${classes.selectMenu}`,
                          }}
                          classes={{
                            select: `${classes.select} select-custom-reg`,
                          }}
                          value={commune ? commune : ''}
                          onChange={handlerChange}
                          inputProps={{
                            name: "commune",
                            id: "commune",
                          }}
                        >
                          <MenuItem
                            disabled
                            classes={{
                              root: classes.selectMenuItem,
                            }}
                            value=""
                          >
                            Selecione una Comuna
                          </MenuItem>
                            {comunes.map(comuna => (
                              <MenuItem
                              classes={{
                                root: `${classes.selectMenuItem}`,
                                selected: `${classes.selectMenuItemSelected} menuItem-capitalize`
                              }}
                              value={comuna.name}
                              key={comuna.id}
                            >
                              {comuna.name}
                            </MenuItem>
                            ))}
                          
                        </Select>
                      <p>{errors.commune && errors.commune}</p>

                      </>
                      ) : null}

                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Card>
                      <CardHeader color="rose" icon>
                        <CardIcon className={`${classes.iconBack} content-icons`}>
                          <IconCalendar />
                        </CardIcon>
                        <h4 className={classes.cardIconTitle}>Fecha de Nacimiento</h4>
                      </CardHeader>
                      <CardBody>
                        <br />
                        <FormControl fullWidth>
                          <Datetime
                            locale="es"
                            onChange={handlerDateChange}
                            timeFormat={false}
                            inputProps={inputProps}
                          />
                          <p>{errors.birthday && errors.birthday}</p>
                        </FormControl>
                      </CardBody>
                    </Card>
                  </GridItem>
                </GridContainer>
                <Button
                  className={`${classes.backButton} happ-background-color`}
                  type="submit"
                >
                  Actualizar Perfil
                </Button>
                <Clearfix />
              </form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      {/* <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon className={`${classes.iconBack} content-icons`}>
                <IconFicha />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                Ficha Clínica 
              </h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <Timeline simple stories={widgetStories} />
                </GridItem>
              </GridContainer>
            </CardBody>  
          </Card>  
        </GridItem>  
      </GridContainer> */}

    </div>
  );
}
